import React, { useEffect, useState } from "react";
import { HotelServices } from "../../../services/hotelSearch/HotelSearchService";

interface RoomImage {
  ID: string;
  Url: string;
  type: string;
  [key: string]: any;
}

interface AmenityListProps {
  EMTCommonID: string;
}

const formatType = (type: string): string => {
  if (!type || typeof type !== "string") return "Others";
  const raw = type.split(/[\|\/]/)[0].trim(); // Split by | or /
  return raw
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

const AmenityList: React.FC<AmenityListProps> = ({ EMTCommonID }) => {
  const [groupedImages, setGroupedImages] = useState<{
    [key: string]: RoomImage[];
  }>({});
  const [selectedType, setSelectedType] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchHotelImages = async () => {
    try {
      setLoading(true);
      const payload = {
        AgentCode: 1,
        EMTCommonID,
        UserName: "HotelAPIUserTest",
        Password: "hotelapitest6NKHbRNN4pSD9G2H",
      };

      const response = await HotelServices.gethoteldetails(payload);
      const images: RoomImage[] = response?.data?.HotelImagesDetail || [];

      const grouped: { [key: string]: RoomImage[] } = {};

      images.forEach((img) => {
        const rawType = img?.type?.trim();
        if (!rawType || rawType === "|" || rawType === "/") return; // ❌ Skip bad types

        const key = formatType(rawType);
        if (!grouped[key]) grouped[key] = [];
        grouped[key].push(img);
      });
      setGroupedImages(grouped);
      const types = Object.keys(grouped);
      setSelectedType(types[0] || "");
    } catch (err) {
      console.error("Failed to fetch hotel images", err);
      setError("Failed to load images.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (EMTCommonID) {
      fetchHotelImages();
    }
  }, [EMTCommonID]);

  if (error) {
    return <div className="text-center text-red-500 py-10">{error}</div>;
  }

  return (
    <div className="bg-gray-50 p-6 rounded-lg shadow-md max-w-6xl mx-auto">
      {/* Tabs */}
      <div className="flex flex-wrap gap-3 mb-6">
        {Object.keys(groupedImages).map((type) => (
          <button
            key={type}
            className={`px-4 py-2 rounded-full border transition ${
              selectedType === type
                ? "bg-info text-white border-blue-600"
                : "bg-white text-gray-700 border-gray-300 hover:bg-blue-50"
            }`}
            onClick={() => setSelectedType(type)}
          >
            {type}
          </button>
        ))}
      </div>

      {/* Images */}
      {loading ? (
        <div className="text-center py-10">Loading images...</div>
      ) : (
        <div className="d-flex gap-3 flex-wrap mt-4">
          {groupedImages[selectedType]?.map((img) => (
            <img
              key={img.ID}
              src={img.Url}
              alt={selectedType}
              className="rounded-md  h-48 object-cover shadow-sm"
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default AmenityList;
